export default __webpack_public_path__ + "static/media/error_500.9fe09c1e.svg";